import styled from "styled-components";

export const ButtonStyled = styled.button`
  border-radius: ${({ borderRadius }) => borderRadius};
  opacity: ${({ opacity }) => opacity};
  font-family: ${({ fontFamily = "Archia" }) => fontFamily};
  display: ${({ display }) => display};
  margin: ${({ margin }) => margin};
  margin-top: ${({ marginTop }) => marginTop};
  margin-left: ${({ marginLeft }) => marginLeft};
  padding: ${({ padding }) => padding};
  outline: ${({ outline }) => outline};
  margin: ${({ m }) => m};
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignItems }) => alignItems};
  background-color: ${({ background = "white" }) => background};
  font-size: ${({ fontSize }) => fontSize};
  font-style: ${({ fontStyle = "Archia" }) => fontStyle};
  border-right: ${({ br }) => br};
  border-left: ${({ bl }) => bl};
  padding: ${({ p }) => p};
  color: ${({ textColor }) => textColor};
  height: ${({ h }) => h};
  width: ${({ w }) => w};
  border: ${({ border = "none" }) => border};
  backdrop-filter: ${({ backdropFilter }) => backdropFilter};
  cursor: ${({ cursor }) => cursor};
  transition: all 0.3s ease; /* Added transition for hover effect */
  position: relative; /* Added position for ::before and ::after */
  overflow: hidden; /* Added overflow for ::before and ::after */
  z-index: 1; /* Added z-index for ::before and ::after */

  &:hover {
    background-color: #000000;
    color: #fff;
    ${({ hrb }) =>
      hrb &&
      `
       border: solid 1px #ffffff;
    `}
  }

  &:before,
  &:after {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 50%;
    height: 120%;
    background-color: #000000;
    transform: scale(2) rotate(12deg);
    width: 0%;
    transition: all 0.3s;
  }

  &:hover:before,
  &:hover:after {
    width: 100%;
    left: 0;
  }
`;
